import React from "react";
import styled from "styled-components";
import mobiledisco from "../../assets/images/services/mobiledisco.jpg";
import djhire from "../../assets/images/services/djhire.jpg";
import weddings from "../../assets/images/services/weddings.jpg";
import birthdays from "../../assets/images/services/birthdays.jpg";
import anniversaries from "../../assets/images/services/anniversarie.jpg";
import corporate from "../../assets/images/services/corporate.jpg";

const Services = () => {
  const DataServices = [
    { service: "Mobile Disco", image: mobiledisco },
    { service: "Dj Hire", image: djhire },
    { service: "Wedding's", image: weddings },
    { service: "Birthday's", image: birthdays },
    { service: "Anniversarie's", image: anniversaries },
    { service: "Corporate", image: corporate },
  ];
  return (
    <MainWrap id="services">
      <Caption>Our Services</Caption>
      <ServicesWrap>
        {DataServices.map((data, idx) => (
          <Service key={idx} bg={data.image}>
            <ServiceCaption>{data.service}</ServiceCaption>
          </Service>
        ))}
      </ServicesWrap>
    </MainWrap>
  );
};

export default Services;

const MainWrap = styled.div`
  width: 100%;
  padding: 50px 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ServicesWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 767px) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  @media (min-width: 767px) and (max-width: 1200px) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Caption = styled.h2`
  margin: 0 0 20px 0;
`;

const Service = styled.div`
  width: 300px;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-image: ${({ bg }) => `url(${bg})`};
  background-size: cover;
  background-position: center;
  position: relative;
`;

const ServiceCaption = styled.h3`
  width: 98%;
  padding: 5px 0;
  text-align: center;
  background: rgba(0, 0, 0, 0.7);
`;
